import React from "react";
import WatchlistToggle from "./WatchlistToggle";
import Sparkline from "./Sparkline";
import {
  formatPrice,
  formatCompact,
  formatPercent,
  percentClass,
} from "../utils/format";

/**
 * Memoized table row — re-renders only when its own props change.
 * Keyboard: Enter/Space opens the detail modal.
 */
const CoinRow = React.memo(function CoinRow({
  coin,
  currency,
  starred,
  onToggleStar,
  onOpen,
}) {
  const spark = coin.sparkline_in_7d?.price;
  const week = coin.price_change_percentage_7d_in_currency;

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onOpen(coin.id);
    }
  };

  return (
    <tr
      className="coin-row"
      tabIndex={0}
      onClick={() => onOpen(coin.id)}
      onKeyDown={handleKeyDown}
      aria-label={`${coin.name} — open details`}
    >
      <td className="mono dim">{coin.market_cap_rank ?? "—"}</td>
      <td>
        <WatchlistToggle
          starred={starred}
          onToggle={() => onToggleStar(coin.id)}
          symbol={coin.symbol}
        />
      </td>
      <td>
        <div className="coin-id">
          <img
            src={coin.image}
            alt=""
            width="20"
            height="20"
            loading="lazy"
            className="coin-logo"
          />
          <span className="coin-name">{coin.name}</span>
          <span className="coin-symbol mono dim">{coin.symbol.toUpperCase()}</span>
        </div>
      </td>
      <td className="mono num">{formatPrice(coin.current_price, currency)}</td>
      <td
        className={`mono num pct ${percentClass(coin.price_change_percentage_1h_in_currency)}`}
      >
        {formatPercent(coin.price_change_percentage_1h_in_currency)}
      </td>
      <td
        className={`mono num pct ${percentClass(coin.price_change_percentage_24h_in_currency)}`}
      >
        {formatPercent(coin.price_change_percentage_24h_in_currency)}
      </td>
      <td
        className={`mono num pct col-7d ${percentClass(week)}`}
      >
        {formatPercent(week)}
      </td>
      <td className="mono num">{formatCompact(coin.market_cap, currency)}</td>
      <td className="mono num">{formatCompact(coin.total_volume, currency)}</td>
      <td className="col-spark">
        <Sparkline data={spark} up={week == null ? true : week >= 0} />
      </td>
    </tr>
  );
});

export default CoinRow;
